import React, { useState } from "react";

import { useMsal } from "@azure/msal-react";

import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  TextField,
  Grid,
  CircularProgress,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import DbUpload from "./FileUpload";
import apiCall from "../utils/apiCall";
import getBase64 from "../utils/getBase64";
import validateFileName from "../utils/validateFileName";

import { IMAGE, PDF } from "../data/constants";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";
import { addFiles, getFiles, getType } from "../redux/slices/typeSlice";
import { loadingforindexes } from "../redux/slices/loadingSlice";
import { addError } from "../redux/slices/errorSlice";
import ConfirmModal from "./ConfirmModal";
import {
  FILE_TYPE_IMAGE,
  FILE_TYPES_PDF,
} from "../data/allowedFileUploadTypes";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface i_value {
  base64: string;
  name: string;
  filetype: string;
}

interface IChatDbUpload {
  open: boolean;
  setOpen: any;
  type: string;
  uploadurl: string;
  deleteurl: string;
  refresh: () => void;
  filelist: string[];
  imagelist:string[]
}

const UploadImagePdf = ({
  open,
  setOpen,
  type,
  uploadurl,
  deleteurl,
  filelist,
  imagelist,
  refresh
}: IChatDbUpload) => {
  const { accounts } = useMsal();
  const accountId = accounts[0]?.username;
  const [value, setValue] = useState<i_value | null>();
  const [name, setName] = useState("");
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const [confirmReplace, setConfirmReplace] = useState("");
  const [loading, setLoading] = useState(false)

  const dispatch = useAppDispatch();

  const handleClose = () => {
    setOpen();
    setValue(null);
    setName("");
  };

  const uploadDb = (confirm: any) => {
    if (type === PDF) {
      const regex = /^[a-zA-Z0-9-]+$/;
      // if (dbType === "pdf") {
      if (name === "") {
        dispatch(addError("Please add a Index name"));
        return;
      } else if (!regex.test(name)) {
        dispatch(
          addError(
            "Index name should be be lowercase, can contain letters, numbers and dashes only, First character must be a letter or number."
          )
        );
        return;
      } else if (
        filelist?.includes(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        ) &&
        confirm !== true
      ) {
        setOpenConfirmModal(true);
        setConfirmReplace(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        );
      } else {
        //   dispatch(startLoading())
        dispatch(loadingforindexes(true));
        setLoading(true) ;
        apiCall("POST", uploadurl, {
          pdf: value?.base64,
          chunk_name:
            name.replace(" ", "_") +
            "---" +
            accountId +
            "---" +
            value?.filetype,
          file_type: value?.filetype,
          user_email: accountId,
        })
          .then((res) => {
            dispatch(addFiles(res.result));
            refresh()
            handleClose();
          })
          .catch((err) => {
            dispatch(addError("Failed to upload the file.Please try again."));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
            setOpen(false);
            setLoading(false)
          });
      }
    } else if (type === IMAGE) {
      if (
        imagelist?.includes(value?.name + "---" + value?.filetype) &&
        confirm !== true
      ) {
        setOpenConfirmModal(true);
        setConfirmReplace(value?.name + "---" + value?.filetype);
      } else {
        dispatch(loadingforindexes(true));
        setLoading(true) ;
        apiCall("POST", uploadurl, {
          image: {
            base64_string: value?.base64,
            filename: value?.name + "---" + value?.filetype,
          },
          user_email: accountId,
        })
          .then((res) => {
            dispatch(addFiles(res.result));
            refresh()
            handleClose();
          })
          .catch((err) => {
            dispatch(addError("Failed to upload the image.Please try again."));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
            setOpen(false);
            setLoading(false)
          });
      }
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
             <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}}  fontSize="small"/>
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <>
          <DbUpload
            content="Drag and drop a file"
            setFile={(file: FileList) => {
              const allowedExtensions = type === "DOCS" ? FILE_TYPES_PDF : FILE_TYPE_IMAGE;
              const validation = validateFileName(file[0], allowedExtensions);
              if (!validation.isValid) {
                dispatch(addError(validation.message));
                return;
              }
              getBase64(file[0]).then((res) => {
                setValue({
                  base64:res.split(",")[1].toString(),
                  filetype: validation.extension,
                  name: validation.safeFileName,
                });
                if ([PDF].includes(type)) setName(validation.safeFileName);
              });
            }}
            file={value}
            fileTypes={type === "DOCS" ? FILE_TYPES_PDF : FILE_TYPE_IMAGE}
          />
          {[PDF].includes(type) && (
            <Grid container justifyContent="center">
              <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                label={type === PDF ? "Enter Index Name" : "DB Name"}
                variant="outlined"
                // sx={{ mt: 2 }}
                fullWidth
                helperText={
                  type === PDF
                    ? "Index name should be be lowercase, can contain letters, numbers and dashes only, First character must be a letter or number."
                    : ""
                }
                sx={{
                  mt: 2,
                  ".MuiFormHelperText-root": {
                    color: "rgba(255,0,0,0.5)",
                    fontSize: "11px",
                  },
                }}
              />
            </Grid>
          )}
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 4 }}
            disabled={!value?.base64 || (!name && [PDF].includes(type))||loading}
            onClick={uploadDb}
            color="primary"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            Upload File
          </Button>
        </>
      </DialogContent>
      <ConfirmModal
        open={openConfirmModal}
        setOpen={() => {
          setOpenConfirmModal(false);
          setOpen(true);
        }}
        onclick={() => {
          setOpenConfirmModal(false);
          apiCall("POST", deleteurl, {
            chunk_name: confirmReplace,
            image_name: confirmReplace,
            user_email: accountId,
          })
            .then((res) => {
              uploadDb(true);
            })
            .catch((err) => {
              dispatch(addError("Failed to delete a file.Please try again."));
            });
        }}
      />
    </Dialog>
  );
};

export default UploadImagePdf;
